import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, Check } from 'lucide-react';
const faqs = [{
  question: "What's Included in Your Website Design and Development Package?",
  title: 'More Than a Website — a Sales and Marketing Engine',
  subtitle: 'Custom-built, SEO-optimized, and designed for conversions.',
  answer: 'Your package includes a fully custom-built one that reflects your brand, not a template. We integrate your Dealer Management System (DMS), create inventory pages optimized for Google and AI search, and provide hands-on training for your staff. Beyond design, we engineer every site to drive leads and sales.',
  features: ['Automated DMS sync: no double entry, no stale listings', 'SEO-friendly architecture and schema for higher rankings', 'Dynamic filters that create lead-generating landing pages', 'ADA-compliant design (WCAG 2.2 AA) for accessibility and tax credit eligibility']
}, {
  question: 'What Makes Your Websites Different From Cookie-Cutter Dealer Platforms?',
  title: 'Custom Builds That Drive Measurable ROI',
  subtitle: 'Own your site, grow your sales, and control your brand.',
  answer: 'Unlike SaaS platforms, our websites are built for your business, not one template. You own the site, avoid lock-in, and benefit from SEO architecture, lightning-fast speeds, and tools like geo-pricing and custom filters.',
  features: []
}, {
  question: 'Can You Integrate My Current Inventory Management System?',
  title: 'Sync Inventory Once, Display Everywhere',
  subtitle: 'Stop double-entry headaches with real-time feeds.',
  answer: 'Yes. DealersChoice integrates directly with the most widely used Dealer Management Systems (DMS) and CRMs, including:',
  features: ['HubSpot', 'Salesforce', 'Lightspeed', 'Dealertrack', 'DockMaster', 'Dealer360', 'Others available upon request'],
  closing: 'This means boats marked on-hand or on-order automatically display online, while sold units archive instantly.'
}, {
  question: 'How Do You Support Multi-Location Dealerships?',
  title: 'One platform, Multiple Stores, Smarter Sales',
  subtitle: 'Location-based pages that cross-sell and simplify management.',
  answer: 'DealersChoice is built for groups of 2–7 locations and beyond. We automatically create location-based dynamic pages so customers can browse the right inventory by store. Inventory sorting by location improves the shopping experience, while cross-store visibility helps move units faster.',
  features: []
}, {
  question: 'Can You Help Us Track Leads and Sales From the Website?',
  title: 'Full Transparency Into What’s Working',
  subtitle: 'Analytics and CRM integration give you the complete picture.',
  answer: "Yes. DealersChoice websites are integrated with Google Analytics and Google Search Console dashboards. You'll receive a 30-day and 90-day post-launch review, plus CRM integrations that automatically log leads, making it easy to measure ROI.",
  features: []
}, {
  question: 'Do You Integrate With Manufacturer Feeds or OEM Programs?',
  title: 'Stay Compliant While Still Ranking Higher',
  subtitle: 'We support OEM requirements without sacrificing SEO.',
  answer: "Yes. We can pull manufacturer feeds to keep your inventory compliant with OEM standards while layering in unique SEO copy and schema that boosts visibility. You don't have to choose between compliance and ranking power.",
  features: []
}, {
  question: 'Do You Syndicate Inventory to Marketplaces Like YachtWorld, Boat Trader, and Boats.com?',
  title: 'Yes — and We Prioritize Direct Leads First',
  subtitle: 'Reach buyers everywhere while keeping your website the hub.',
  answer: 'Yes. We feed inventory to YachtWorld, Boats.com, and Boat Trader (plus optional feeds to Google Shopping, Facebook Marketplace, eBay, and more). At the same time, our SEO and lead tools prioritize your own website as the main conversion point — so you own the lead.',
  features: []
}, {
  question: 'Are Your Websites ADA Compliant?',
  title: 'Accessibility That Expands Your Audience and Protects Your Business',
  subtitle: 'WCAG 2.2 AA compliance with potential tax credit.',
  answer: 'Yes. All DealersChoice websites are built to WCAG 2.2 AA standards. If your dealership has under 30 full-time employees, you may also qualify for a $5,000 U.S. tax credit (consult your tax advisor).',
  features: []
}, {
  question: "Do I Own My Website Once It's Paid Off?",
  title: "Yes — It's Your Asset, Not Our Property",
  subtitle: 'Unlike SaaS platforms, your site becomes yours to keep.',
  answer: "Once the initial build is fully paid, you own the website, design, and code. The only exception is our proprietary feeds/API plugin, which powers automated imports and syndication — it's licensed as part of your service agreement. If you ever switch providers, your site continues to function, and a new solution can replace the feeds.",
  features: []
}, {
  question: 'Do You Offer Ongoing Support and Updates After Launch?',
  title: 'Continuous Support That Protects Your Investment',
  subtitle: 'Not just hosting — proactive management and strategy.',
  answer: 'Yes. Our monthly service agreements include far more than "server space".',
  features: ['High-performance security with malware scans and firewalls', 'Nightly backups with 14-day retention', 'WordPress core + plugin updates', 'SaaS API management for inventory feeds', '24/7 monitoring and rapid support response', 'Quarterly marketing reviews and strategy sessions']
}, {
  question: 'Can I Make Updates to My Site Myself?',
  title: 'Freedom to Edit Without Waiting on a Ticket',
  subtitle: 'Training is included so your team can update quickly.',
  answer: "Yes. We provide hands-on training sessions so your staff can update inventory, edit copy, add specials, and manage promotions directly. You'll never feel locked out of your own site. And if you need advanced changes, our support team is always available.",
  features: []
}, {
  question: 'How Long Does it Take to Build a New Dealer Website',
  title: 'A Streamlined Process With Predictable Timelines',
  subtitle: 'From vision to launch in weeks, not endless months.',
  answer: 'Most DealersChoice websites launch in 3–5 months, depending on complexity and the number of integrations. We use a proven workbook process to capture your ideas, inventory needs, and marketing goals, then turn them into a site that works hard from day one.',
  features: ['Discovery: we map goals, integrations, and compliance needs', 'Design: custom layouts reflecting your brand and inventory flow', 'Development: integrations, SEO, and testing', 'Launch: training + 30- and 90-day reviews to ensure success']
}, {
  question: 'Do You Provide Training for My Team?',
  title: 'Empowering Your Staff to Manage the Site',
  subtitle: "Hands-on sessions so you're in control.",
  answer: "Yes. After launch, we deliver private training sessions tailored to your staff's roles. They'll learn how to add inventory, edit content, and manage offers without needing to submit tickets.",
  features: []
}, {
  question: 'How Long Have You Been Doing Marine Marketing?',
  title: 'Two Decades of Marine Expertise, Nearly Three in Digital',
  subtitle: 'Trusted experience that drives results.',
  answer: 'DealersChoice is powered by Mannix Marketing, which has been doing marine and marina marketing for over 20 years and digital marketing overall for 29 years.',
  features: []
}, {
  question: 'How Much Experience Does DealersChoice Have?',
  title: 'Decades of Marketing and Web Expertise That Deliver Results',
  subtitle: 'Since 1996, is powered by a U.S.-based team of experts.',
  answer: "DealersChoice is powered by Mannix Marketing, a digital agency that's been helping businesses succeed online since 1996. With nearly three decades of experience, we've built websites and marketing campaigns that drive leads and sales for marinas, boat dealers, hospitality businesses, and powersports companies. Our depth of industry expertise means we understand not only the challenges of marine and dealership marketing, but also the opportunities to grow your broader business.",
  features: []
}, {
  question: 'What Happens If I Want to Switch Providers in the Future?',
  title: 'Your Site Keeps Working — No Lock-in',
  subtitle: 'Transparency builds trust, and flexibility protects you.',
  answer: "If you decide to move away from DealersChoice, you take your website with you — design, code, and content. The only piece you'd need to replace is our licensed API/feeds plugin. This ensures you aren't locked into our platform but continue to benefit from your investment.",
  features: []
}, {
  question: "What Happens If My Site Goes Down or There's a Technical Issue?",
  title: 'Peace of Mind With 24/7 Monitoring',
  subtitle: 'Backups and rapid response built into your plan.',
  answer: 'We monitor sites 24/7. If an issue arises, nightly backups and built-in redundancies ensure minimal downtime. Our support team is available to resolve problems quickly.',
  features: []
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-20 bg-gray-50" data-id="element-37">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-38">
        <div className="text-center mb-16" data-id="element-39">
          <h2 className="text-3xl md:text-4xl font-bold text-[#0A2540] mb-4" data-id="element-40">
            Website Design & Development FAQ
          </h2>
          <p className="text-xl text-gray-600" data-id="element-41">
            Everything you need to know about our custom boat dealer websites.
          </p>
        </div>

        <div className="space-y-4" data-id="element-42">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden" data-id="element-43">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-gray-50 transition-colors" data-id="element-44">
                <span className="text-lg font-bold text-[#0A2540] pr-8" data-id="element-45">
                  {faq.question}
                </span>
                <ChevronDown className={`w-6 h-6 text-[#0A2540] flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-46" />
              </button>

              <AnimatePresence data-id="element-47">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} className="overflow-hidden" data-id="element-48">
                    <div className="px-6 pb-6 pt-2 space-y-4" data-id="element-49">
                      <div className="border-l-4 border-[#D4AF37] pl-4" data-id="element-50">
                        <h4 className="text-xl font-bold text-[#0A2540] mb-1" data-id="element-51">
                          {faq.title}
                        </h4>
                        <p className="text-sm text-[#D4AF37] font-semibold mb-3" data-id="element-52">
                          {faq.subtitle}
                        </p>
                      </div>

                      <p className="text-gray-700 leading-relaxed" data-id="element-53">
                        {faq.answer}
                      </p>

                      {faq.features.length > 0 && <ul className="space-y-2 mt-4" data-id="element-54">
                          {faq.features.map((feature, i) => <li key={i} className="flex items-start" data-id="element-55">
                              <Check className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5 mr-3" data-id="element-56" />
                              <span className="text-gray-700" data-id="element-57">{feature}</span>
                            </li>)}
                        </ul>}

                      {faq.closing && <p className="text-gray-700 leading-relaxed mt-4 italic" data-id="element-58">
                          {faq.closing}
                        </p>}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}